import * as yup from "yup"

export const schemaValidation = yup.object().shape({
  prefix: yup.string().required(),
  prefixSeparator: yup.string().required(),
  suffix: yup.string().required(),
  suffixSeparator: yup.string().required(),
  length: yup.number().integer().max(100).min(0).required()
})